module.exports = "<button class=\"btn btn-default\" [routerLink]=\"['/crear-perfil']\">Crear Perfil</button>\n<div *ngIf=\"profiles\">\n    <div *ngFor=\"let profile of profiles\">\n        <a [routerLink]=\"['/perfil', profile.id]\">{{profile.name}}</a>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/steel-profile/steel-profile-list/steel-profile-list.component.html
// module id = 808
// module chunks = 0